// COMMON
export const SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING'
export const EMPTY_COMMON = 'EMPTY_COMMON'
export const EMPTY_CATALOG = 'EMPTY_CATALOG'
export const SET_SIDEBAR_STATUS = 'SET_SIDEBAR_STATUS'

// AUTH
export const SAVE_STOREID = 'SAVE_STOREID'
export const SAVE_COMMONTOKEN = 'SAVE_COMMONTOKEN'
export const REMOVE_COMMONTOKEN = 'REMOVE_COMMONTOKEN'
export const SAVE_CURRENT_USER = 'SAVE_CURRENT_USER'
export const REMOVE_CURRENT_USER = 'REMOVE_CURRENT_USER'
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER'
export const EMPTY_AUTH = 'EMPTY_AUTH'

// CATALOG - 
// categories
export const ADD_CATAGORIES = 'ADD_CATAGORIES'
